import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { jerusalemDateKey } from '@/lib/ashkelon-crossword';
import { getCrosswordForDate } from '@/server/content';
import { requireAdminAccess } from '@/server/functions/auth';

const dateKeySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const loadCrosswordPuzzleFn = createServerFn({ method: 'GET' })
    .validator(z.object({ dateKey: dateKeySchema }))
    .handler(async ({ data }) => {
        const today = jerusalemDateKey();
        if (data.dateKey !== today) {
            await requireAdminAccess();
        }

        return getCrosswordForDate(data.dateKey);
    });
